import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import {
  foodGallery2,
  foodGallery,
  galleryDivider,
  mobileGallery,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileGallery} w="100%" alt="Food Gallery" />
          <CFImage src={galleryDivider} w="100%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" m="0 auto">
          <CFImage src={foodGallery} w="100%" alt="Food Gallery" m="0 auto" />
        </CFView>
        <CFView m="0 auto">
          <CFView
            column
            justifyEnd
            alignCenter
            h="550px"
            w="100%"
            maxWidth="1400px"
            image={`url(${foodGallery2}) bottom / cover no-repeat`}
            style={{ backgroundAttachment: 'fixed' }}
          ></CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
